import { Directory } from "../../../../../domain/drawing";
import { FormatReference } from "../../../../../domain/format";
import { IFormatTreeSourceFilterable } from "./IFormatTreeSourceFilterable";
import { ITreeSource } from "./ITreeSource";

export class FilterableFormatTreeSource implements ITreeSource<FormatReference> {
  constructor(private _treeSource: ITreeSource<FormatReference>, private _filter: IFormatTreeSourceFilterable) {
  }

  get entityName(): string {
    return this._treeSource.entityName;
  }

  public async getTree(): Promise<Directory<string, FormatReference>[]> {
    const tree = await this._treeSource.getTree();
    return this._filter ? this._filter.filter(tree) : tree;
  }

  get managementKey(): string {
    return this._treeSource.managementKey;
  }
}
